import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
    creditBuilderData:{},
    error:'',
    status:'idle',
    isDataSet:0
};

export const fetchCreditBuilder = createAsyncThunk('credit-builder/fetchCreditBuilder', async () => {
    let accessToken = localStorage.getItem('accessToken');
    let formData = new FormData();
    formData.append("Token",accessToken);
    let response = await axios.post('form/getCreditBuilder',formData);
    if (response.status === 200) {
        if(response.data.error!=2){
            return response.data;
        }else{
            removeLocalStorage();
            window.location.href = "/";
        }
    }else{
        throw new Error(response.statusText)
    }
});


const removeLocalStorage = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("company_id");
    localStorage.removeItem("company_logo");
    localStorage.removeItem("accessToken");
}


const CreditBuilderSlice = createSlice({
    name:'credit-builder',
    initialState,
    reducers:{
        blankCreditBuilder:(state)=>{
            state.status = "idle";
            state.creditBuilderData = {};
        },
        setIsDataSet:(state,action) => {
            state.isDataSet = action.payload;
        }
    },
    extraReducers:(builder) => {
        builder.addCase(fetchCreditBuilder.pending, (state)=>{
            state.status = 'loading';
        })
        builder.addCase(fetchCreditBuilder.fulfilled,(state,action)=>{
            state.status = 'succeeded';
            state.creditBuilderData = action.payload;
            state.error = '';
        })
        builder.addCase(fetchCreditBuilder.rejected,(state,action)=>{
            state.status = 'failed';
            state.creditBuilderData = {};
            state.error = action.error.message;
        })
    }
});

export const {blankCreditBuilder,setIsDataSet} = CreditBuilderSlice.actions;

export default CreditBuilderSlice.reducer;
